import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../hooks/useTheme';

// Components
import Header from '../components/landing/Header';
import RegisterForm from '../components/auth/RegisterForm';
import Footer from '../components/landing/Footer';

const RegisterPage = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={`landing-page theme-${theme}`}>
            <Helmet>
                <title>Crear Cuenta - Laptops.pe</title>
                <meta name="description" content="Crea tu cuenta en Laptops.pe y accede a ofertas exclusivas, historial de pedidos y más beneficios." />
                <meta property="og:title" content="Crear Cuenta - Laptops.pe" />
                <meta property="og:description" content="Crea tu cuenta en Laptops.pe y accede a beneficios exclusivos." />
                <meta property="og:type" content="website" />
                <link rel="canonical" href={`${process.env.REACT_APP_SITE_URL}/registro`} />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Header theme={theme} onToggleTheme={toggleTheme} />
            
            <main className="landing-main">
                <div className="container py-6">
                    <div className="flex justify-content-center">
                        <div className="col-12 md:col-8 lg:col-6 xl:col-5">
                            <div className="surface-card border-round p-6 shadow-2">
                                <div className="text-center mb-6">
                                    <h1 className="text-3xl font-bold mb-2">Crear Cuenta</h1>
                                    <p className="text-color-secondary">
                                        Únete a WINS Technology y disfruta de beneficios exclusivos
                                    </p>
                                </div>
                                
                                <RegisterForm />
                                
                                <div className="text-center mt-4">
                                    <p className="text-color-secondary">
                                        ¿Ya tienes una cuenta?{' '}
                                        <a href="/login" className="text-primary font-semibold">
                                            Inicia sesión aquí
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            
            <Footer />
        </div>
    );
};

export default RegisterPage;
